import { PageHeader } from "@ant-design/pro-components";
import { CopyAllOutlined, Message } from "@mui/icons-material";
import { Alert, Button, Card, Form, Input, message, Select, Textarea } from "antd";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";
import styles from "./PredefinedSmsCreate.module.css";

const PredefinedSmsCreate = () => {
  const [form] = Form.useForm();
  const [key, setKey] = useState("");
  const [message, setMessage] = useState("");

  const [result, setResult] = useState({
    message: "",
    type: "",
  });

  const sendRequest = () => {
    setResult({ message: "", type: "" });
    api
      .post("/smspredefined/create", { key: key, text: message })
      .then((res) => {
        if (res.data?.status === "success") {
          setResult({
            message: "قالب با موفقیت ایجاد شد.",
            type: "success",
          });
        } else {
          setResult({
            message: "مشکلی در ایجاد پیش آمده است.",
            type: "error",
          });
        }
      })
      .catch((error) => {
        let errorMessage = error.response.data?.error?.message ?? "مشکلی در ایجاد پیش آمده است.";
        setResult({
          message: errorMessage,
          type: "error",
        });
      });
  };

  return (
    <div className={styles.PredefinedSmsCreate}>
      <PageHeader title="ایجاد قالب" avatar={{ icon: <Message />, size: "large", style: { paddingTop: "8px" } }} />

      <Card className={styles.Form}>
        <Form form={form} name="validateOnly" layout="vertical" autoComplete="off">
          <Form.Item name="key" label="عنوان (شامل حروف و اعداد انگلیسی و خط تیره)">
            <Input value={key} onChange={(e) => setKey(e.target.value)} />
          </Form.Item>

          <div className={styles.MessageTextareaContainer}>
            <label>متن پیام</label>
            <Input.TextArea name="message" value={message} onChange={(e) => setMessage(e.target.value)} rows={5} />
          </div>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                sendRequest();
              }}
            >
              ایجاد
            </Button>
          </Form.Item>

          {result.message && <Alert message={result.message} type={result.type} />}
        </Form>
      </Card>
    </div>
  );
};

export default memo(PredefinedSmsCreate);
